import { LoginSuccessPage, NavigationHandler, PlatformProvider } from '@elva/platform';
import { Outlet } from 'react-router-dom';
import { aiReceptionistPlatformConfig } from '@/app/config/platform';

const LOGO_SRC = '/logo.svg';

export function AppRoot() {
  return (
    <PlatformProvider config={aiReceptionistPlatformConfig} logoSrc={LOGO_SRC}>
      <NavigationHandler />
      <Outlet />
    </PlatformProvider>
  );
}

export function LoginOkRoute() {
  return <LoginSuccessPage logoSrc={LOGO_SRC} redirectTo="/" />;
}
